var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculatorMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,2H12C9.2431641,2,7,4.2431641,7,7v34c0,2.7568359,2.2431641,5,5,5h24c2.7568359,0,5-2.2431641,5-5V7 C41,4.2431641,38.7568359,2,36,2z M39,41c0,1.6542969-1.3457031,3-3,3H12c-1.6542969,0-3-1.3457031-3-3V7 c0-1.6542969,1.3457031-3,3-3h24c1.6542969,0,3,1.3457031,3,3V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,7H15c-1.6542969,0-3,1.3457031-3,3v2c0,1.6542969,1.3457031,3,3,3h18c1.6542969,0,3-1.3457031,3-3v-2 C36,8.3457031,34.6542969,7,33,7z M34,12c0,0.5517578-0.4482422,1-1,1H15c-0.5517578,0-1-0.4482422-1-1v-2 c0-0.5517578,0.4482422-1,1-1h18c0.5517578,0,1,0.4482422,1,1V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,19c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3s3-1.3457031,3-3S16.6542969,19,15,19z M15,23 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1s1,0.4482422,1,1S15.5517578,23,15,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,19c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3s3-1.3457031,3-3S25.6542969,19,24,19z M24,23 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1s1,0.4482422,1,1S24.5517578,23,24,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,19c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3s3-1.3457031,3-3S34.6542969,19,33,19z M33,23 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1s1,0.4482422,1,1S33.5517578,23,33,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,27c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3s3-1.3457031,3-3S16.6542969,27,15,27z M15,31 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1s1,0.4482422,1,1S15.5517578,31,15,31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,27c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3s3-1.3457031,3-3S25.6542969,27,24,27z M24,31 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1s1,0.4482422,1,1S24.5517578,31,24,31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,35c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3s3-1.3457031,3-3S16.6542969,35,15,35z M15,39 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1s1,0.4482422,1,1S15.5517578,39,15,39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,35c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3s3-1.3457031,3-3S25.6542969,35,24,35z M24,39 c-0.5517578,0-1-0.4482422-1-1s0.4482422-1,1-1s1,0.4482422,1,1S24.5517578,39,24,39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,27c-1.6542969,0-3,1.3457031-3,3v8c0,1.6542969,1.3457031,3,3,3s3-1.3457031,3-3v-8C36,28.3457031,34.6542969,27,33,27 z M34,38c0,0.5517578-0.4482422,1-1,1s-1-0.4482422-1-1v-8c0-0.5517578,0.4482422-1,1-1s1,0.4482422,1,1V38z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorMedium);
export default __webpack_public_path__ + "static/media/calculator--medium.c77566a70ad1a3abdcea235c45a64908.svg";
export { ForwardRef as ReactComponent };